module.exports = __webpack_public_path__ + "img/doorsensor-old.5fac9491.png";